import React, { useMemo} from "react";
import PT from "prop-types";
import Rest from "_c/Rest";
import * as S from "./styled";
import Avatar from "_c/Avatar";

const ButtonRenderer = () => {
  return (
    <S.RestButton aria-label="Показать больше мастеров" medium>
      <span>...</span>
    </S.RestButton>
  );
};
const MasterRenderer = ({ _id, user, selectMaster, selectedMaster }) => {
  const isSelected = selectedMaster === _id;
  const onSelect = () => {
    selectMaster(isSelected ? null : _id);
  };
  const { fullName, altText } = useMemo(() => {
    const fullName = [user.first_name, user.last_name]
      .filter(Boolean)
      .join(" ");
    return {
      fullName,
      altText: "pro-" + fullName.replace(/\s+/g, "-") + "-in-lakki-crm",
    };
  }, [user.first_name, user.last_name]);
  return (
    <S.Master selected={isSelected} onClick={onSelect} title={fullName}>
      <Avatar alt={altText} size="lg" avatar={user.avatar} sex={user.sex} />
    </S.Master>
  );
};

const MasterSelector = (props) => {
  return (
    <S.Wrap>
      <Rest
        itemProps={{
          selectMaster: props.selectMaster,
          selectedMaster: props.selectedMaster,
        }}
        items={props.masters}
        itemRenderer={MasterRenderer}
        restButtonRenderer={ButtonRenderer}
        restContainerRenderer={S.RestContainer}
        limit={2}
      />
    </S.Wrap>
  );
};
MasterSelector.propTypes = {
  masters: PT.array,
  selectMaster: PT.func.isRequired,
  selectedMaster: PT.string,
};
export default MasterSelector;
